import { DestroyRef, inject } from '@angular/core';
import { MonoTypeOperatorFunction, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

/**
 * RxJS operator that automatically unsubscribes when the component is destroyed.
 * Uses Angular 16+ DestroyRef API for automatic cleanup.
 * 
 * @example
 * ```typescript
 * this.myService.data$
 *   .pipe(takeUntilDestroyed())
 *   .subscribe(data => console.log(data));
 * ```
 * 
 * Note: This must be called in an injection context (constructor or field initializer)
 */
export function takeUntilDestroyed<T>(): MonoTypeOperatorFunction<T> {
  const destroyRef = inject(DestroyRef);
  const destroyed$ = new Subject<void>();
  
  destroyRef.onDestroy(() => {
    destroyed$.next();
    destroyed$.complete();
  });
  
  return takeUntil(destroyed$);
}
